import QrCode from './qrcode/qrcode.service';
import ValueChecker from './valueChecker/valueChecker.service';

export default angular.module('app.utils', [])
	.service(QrCode.id(), QrCode)
	.service(ValueChecker.id(), ValueChecker)
	.name;
